var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNashua(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 574 83",
    style: {
      enableBackground: "new 0 0 574 83"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#14284B;}\n\t.st1{fill:#01223E;}\n\t.st2{fill:#FF0014;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M391.4,32.3l7.9,14.1h-18.1l7.7-14.1H391.4z M355.9,63.6h15.8l4.1-7.8h28.7l4.4,7.8h15.8l-25.4-43.9h-18.5 L355.9,63.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M154.4,51.9c0,9.5,5.2,11.8,18.1,11.8h17.2c18.8,0,23.1-2,23.1-13.8c0-12.8-5.1-14.1-27.1-14 c-15.2,0.1-16.9-0.1-16.9-3.9c0-2.4,2.2-3.4,5.4-3.4h15.7c6.5,0,6.9,1.3,6.9,4.5h14.2v-1.4c0-7.7-1.5-13-17.9-13h-19.8 c-17.9,0-18.7,6.1-18.7,14.1c0,10.8,2.4,13.2,23.8,13.2c18.3,0,19.9,0.2,19.9,4.1c0,3.4-3.1,3.7-6.1,3.7h-17.4 c-4.1,0-6.1-0.4-6.1-5h-14.2V51.9z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "224.4,63.7 238.6,63.7 238.6,47.1 268.5,47.1 268.5,63.7 282.7,63.7 282.7,19.8 268.5,19.8  268.5,35.4 238.6,35.4 238.6,19.8 224.4,19.8  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M295.4,48c0,10.9,5.9,16.1,19,16.1h20.3c13,0,19-5.2,19-16.1V19.8h-14.2v25.4c0,5.6-2.1,7.7-7.9,7.7h-14.1 c-5.8,0-7.9-2.2-7.9-7.7V19.8h-14.2V48z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M117,32.3l7.9,14.1h-18.1l7.7-14.1H117z M81.5,63.6h15.8l4.1-7.8h28.7l4.4,7.8h15.8L125,19.7h-18.5L81.5,63.6 z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "59.6,49.9 34.5,19.8 12.5,19.8 12.5,63.7 26.7,63.7 26.7,33.5 28.3,33.5 53.4,63.7 75.4,63.7  75.4,19.8 61.2,19.8 61.2,49.9  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "532.7,63.6 507.2,19.7 536.1,19.7 561.5,63.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "440.6,63.6 415.2,19.7 425.6,19.7 451,63.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "458.5,63.6 433.1,19.7 445.4,19.7 470.8,63.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "478.4,63.6 453,19.7 469.7,19.7 495.1,63.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "502.6,63.6 477.2,19.7 499.7,19.7 525.1,63.6  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNashua);
export default __webpack_public_path__ + "static/media/nashua.ca5ace5ec85c00843d479fec8656a98f.svg";
export { ForwardRef as ReactComponent };